import { render, staticRenderFns } from "./productShortcut.vue?vue&type=template&id=39687c06&scoped=true&"
import script from "./productShortcut.vue?vue&type=script&lang=js&"
export * from "./productShortcut.vue?vue&type=script&lang=js&"
import style0 from "./productShortcut.vue?vue&type=style&index=0&id=39687c06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39687c06",
  null
  
)

export default component.exports